export const facultyPublicationData = [
  ["Dr. Y . S. Rao", 0, 1, 1, 0, 0, 0, 2, 4, 1],
  ["Dr. R. R. Sawant", 0, 2, 2, 0, 1, 0, 2, 2, 1],
  ["Dr. K. T. Talele", 0, 1, 2, 0, 2, 2, 0, 5, 2],
  // ["Dr. D. D. Ambawade", 0, 1, 0, 0, 3, 0, 0, 9, 0],
  ["Dr. Reena Sonkusare", 2, 0, 0, 1, 0, 0, 2, 5, 0],
  ["Dr. Sukanya Kulkarni", 0, 1, 0, 0, 1, 0, 1, 5, 0],
  ["Dr. D. C. Karia", 0, 3, 1, 0, 5, 0, 0, 8, 0],
  ["Dr. R. G. Sutar", 0, 1, 0, 0, 2, 0, 1, 3, 0],
  ["Dr. N. A. Bhagat", 0, 4, 0, 0, 4, 0, 0, 5, 0],
  ["Dr. Sujata Kulkarni", 0, 0, 0, 2, 3, 0, 2, 3, 0],
  ["Prof. Manish Parmar", 0, 0, 0, 0, 0, 0, 0, 3, 0],
  ["Dr. P. V. Kasambe", 0, 0, 3, 0, 1, 0, 2, 5, 0],
  ["Dr. Anand Mane", 0, 1, 1, 0, 0, 0, 1, 0, 0],
  ["Dr. P. H. Shah", 2, 0, 0, 2, 5, 0, 0, 5, 0],
  ["Prof. M. R. Bansode", 1, 1, 0, 2, 2, 0, 0, 6, 0],
  ["Prof. G.T. Haldankar", 0, 1, 0, 0, 2, 0, 0, 3, 0],
  ["Prof. Milind Paraye", 1, 0, 0, 0, 1, 0, 0, 1, 0],
  ["Prof. Priya Chimurkar", 0, 2, 0, 4, 0, 0, 4, 0],
  ["Prof. Najib Ghatte", 1, 0, 1, 0, 2, 0, 1, 6, 0],
  ["Prof. Pallavi Malame", 0, 0, 0, 0, 2, 0, 1, 0, 0],
  ["Dr. Amol Deshpande", 0, 3, 0, 0, 2, 0, 1, 7, 0],
  ["Prof. Sneha Weakey", 0, 0, 0, 0, 0, 0, 0, 3, 0],
  ["Dr. S. S. Rathod", 1, 1, 0, 2, 5, 1, 1, 5, 0],
  ["Prof. Vijaya Kamble", 0, 0, 0, 0, 0, 0, 1, 0, 0],
];

export const facultyPublicationData2 = [
    {
    'Name of Faculty': 'Dr. Y. S. Rao',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 1 },
    '2022-2023': { Journal: 0, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 2, Conference: 4, Patent: 1 }
  },
  {
    'Name of Faculty': 'Dr. R. R. Sawant',
    '2023-2024': { Journal: 0, Conference: 2, Patent: 2 },
    '2022-2023': { Journal: 0, Conference: 1, Patent: 0 },
    '2021-2022': { Journal: 2, Conference: 2, Patent: 1 }
  },
  {
    'Name of Faculty': 'Prof. K. T. Talele',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 2 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 2 },
    '2021-2022': { Journal: 0, Conference: 5, Patent: 2 }
  },
  // {
  //   'Name of Faculty': 'Prof. D. D. Ambawade',
  //   '2023-2024': { Journal: 0, Conference: 1, Patent: 0 },
  //   '2022-2023': { Journal: 0, Conference: 3, Patent: 0 },
  //   '2021-2022': { Journal: 0, Conference: 9, Patent: 0 }
  // },
  {
    'Name of Faculty': 'Dr. Reena Sonkusare',
    '2023-2024': { Journal: 2, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 1, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 2, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. Sukanya Kulkarni',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 1, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. D. C. Karia',
    '2023-2024': { Journal: 0, Conference: 3, Patent: 1 },
    '2022-2023': { Journal: 0, Conference: 5, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 8, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. R. G. Sutar',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 3, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. N. A. Bhagat',
    '2023-2024': { Journal: 0, Conference: 4, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 4, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. Sujata Kulkarni',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 2, Conference: 3, Patent: 0 },
    '2021-2022': { Journal: 2, Conference: 3, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Manish Parmar',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 3, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. P. V. Kasambe',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 3 },
    '2022-2023': { Journal: 0, Conference: 1, Patent: 0 },
    '2021-2022': { Journal: 2, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Anand Mane',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 1 },
    '2022-2023': { Journal: 0, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 0, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. P. H. Shah',
    '2023-2024': { Journal: 2, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 2, Conference: 5, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. M. R. Bansode',
    '2023-2024': { Journal: 1, Conference: 1, Patent: 0 },
    '2022-2023': { Journal: 2, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 6, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. G.T. Haldankar',
    '2023-2024': { Journal: 0, Conference: 1, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 3, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Milind Paraye',
    '2023-2024': { Journal: 1, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 1, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 1, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Priya Chimurkar',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 2 },
    '2022-2023': { Journal: 0, Conference: 4, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 4, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Najib Ghatte',
    '2023-2024': { Journal: 1, Conference: 0, Patent: 1 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 6, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Pallavi Malame',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 0, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. Amol Deshpande',
    '2023-2024': { Journal: 0, Conference: 3, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 2, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 7, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Sneha Weakey',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 0, Conference: 3, Patent: 0 }
  },
  {
    'Name of Faculty': 'Dr. S. S. Rathod',
    '2023-2024': { Journal: 1, Conference: 1, Patent: 0 },
    '2022-2023': { Journal: 2, Conference: 5, Patent: 1 },
    '2021-2022': { Journal: 1, Conference: 5, Patent: 0 }
  },
  {
    'Name of Faculty': 'Prof. Vijaya Kamble',
    '2023-2024': { Journal: 0, Conference: 0, Patent: 0 },
    '2022-2023': { Journal: 0, Conference: 0, Patent: 0 },
    '2021-2022': { Journal: 1, Conference: 0, Patent: 0 }
  }
]

export const facultyPublicationCitations = [
["Dr. S. S. Rathod", 690, 13, 21, 75, 395, 11],
["Dr. R. G. Sutar", 118, 6, 6, 21, 62, 5],
["Dr. D. C. Karia", 538, 12, 20, 72, 275, 9],
["Prof. K. T. Talele", 325, 12, 12, 45, 161, 8],
["Prof. N. A. Bhagat", 122, 5, 4, 18, 46, 4],
["Prof. P. V . Kasambe", 135, 7, 4, 16, 74, 5],
["Prof. P. H. Shah", 126, 6, 4, 21, 57, 4],
["Prof. M. R. Bansode", 90, 4, 3, 15, 54, 4],
["Prof. G.T. Haldankar", 48, 3, 1, 12, 17, 2],
["Prof. Priya Chimurkar", 157, 7, 6, 13, 72, 5],
["Prof. Najib Ghatte", 46, 4, 1, 8, 12, 2],
["Dr. Y . S. Rao", 563, 10, 10, 42, 221, 7],
["Dr. R. R. Sawant", 468, 12, 12, 32, 302, 8],
// ["Prof. D. D. Ambawade", 632, 13, 20, 51, 368, 11],
["Dr. Reena Sonkusare", 370, 11, 12, 33, 183, 8],
["Prof. Manish Parmar", 216, 7, 6, 16, 136, 5],
["Dr. Sukanya Kulkarni", 116, 7, 3, 24, 74, 6],
["Dr. Sujata Kulkarni", 295, 8, 6, 23, 33, 4],
["Prof. Anand Mane", 25, 3, 0, 14, 11, 2],
["Prof. Vijaya Kamble", 208, 4, 3, 17, 140, 4],
["Prof. Milind Paraye", 28, 3, 0, 8, 18, 3],
["Prof. Pallavi Malame", 33, 2, 1, 2, 4, 2],
["Dr. Amol Deshpande", 325, 8, 8, 17, 57, 5],
["Prof. Sneha Weakey", 26, 1, 1, 4, 27, 2]
];
